import { Sidebar } from "components/evaluate-panel-options/Sidebar";
import RightContent from "components/evaluate-panel-options/list/index";
import Page from "components/wrappers/Page";

const PanelList = () => (
  <Page>
    <Sidebar />
    <RightContent />
  </Page>
);

export default PanelList;
